import { gql } from "@apollo/client";

export default gql`
  mutation deletePlatform($type: PlatformType!, $metaData: DeletePlatformTypeInput!){
    deletePlatform(type: $type, metaData: $metaData){
        success
        data
        code
        message
    }
}
`
